import React, { useState } from 'react';
import { Modal, ModalBody, ResidentialUnitExtraData } from '@ygtechnologies/bygr-frontend-component-library';
import { Trans } from '@lingui/react/macro';
import { useGetProjectId } from '@/utils/hooks';
import { useResidentialUnitsByProjectId } from '@/services/residential-units/residential-units.hooks';
import { UnitStatusColor, UnitStatusDisplay } from '@/seller/components/options/OptionGroupStatusDisplay/UnitStatusDisplay';
import { Button } from '@ygtechnologies/rubus-ui';
import theme from './LinkedUnitsModal.module.scss';
import { useHistory } from 'react-router';

export interface LinkedUnitsModalProps {
    roomId?: number;
    isModalOpen: boolean;
    setIsModalOpen: (isModalOpen: boolean) => void;
}

export const LinkedUnitsModal: React.FC<LinkedUnitsModalProps> = ({ roomId, isModalOpen, setIsModalOpen }) => {
    const history = useHistory();
    const projectId = useGetProjectId();
    const { data: units } = useResidentialUnitsByProjectId(projectId);

    const getUnitStatus = (unit: ResidentialUnitExtraData): UnitStatusColor => {
        if (unit.projectTags.some(x => x.id === roomId)) return "green"
        return 'red';
    };

    const onUnitClick = (residentialUnitId: number) => {
        history.push(`/projects/${projectId}/residential-units/${residentialUnitId}/dashboard`);
    };
    return (
        <Modal isOpen={isModalOpen} toggle={() => setIsModalOpen(false)}>
            <ModalBody>
                <div className={theme.unitsHeader}>
                    <span className={theme.unitsTitle}><Trans>Linked units</Trans></span>
                    <span><Trans>See below which apartment the rooms is linked to</Trans></span>
                </div>
                <UnitStatusDisplay projectId={projectId ?? 0} value={units?.map(u => ({
                    residentialUnitId: u.id,
                    status: getUnitStatus(u as unknown as ResidentialUnitExtraData),
                })) ?? []} collapsible={true} onUnitClick={onUnitClick} />
            </ModalBody>
        </Modal>
    );
};